/**
 * 创建人：张丽莉
 * 时间：2019-8-16
 * 描述：打印表格
 * 使用说明: 
 * 更新记录: 
 */
import { Component,OnInit, Output, EventEmitter,ViewChild, Input, ElementRef} from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
declare var $: any;
@Component({
  selector: 'sw-table-print',
  templateUrl: './sw-table-print.component.html',
  styleUrls: ['./sw-table-print.component.css']
})
export class SwTablePrintComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent; //弹出层组件
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  // printCSS: string[];
  // printStyle: string;
  // printBtnBoolean = true;
  /**
   * headerLogo 预览表格弹框的标题 初始值为打印 参数可传，也可不传
   */
  headerLogo:string = "打印"; 
   /**
   * datasTitle 预览表格和打印表格的表头数据 如 [{descript: '文物类别',name: 'name'},{descript: '数量',name: 'count'}]
   * 
   */
  datasTitle:any = [];
    /**
   * datas 预览表格和打印表格的表格数据 如 [{name: '金银器',count: '0'},]
   * 
   */
  datas: any = [];
  constructor() {
    // this.printCSS = ['assets/Theme/default/bootstrap.min.css','assets/Theme/default/Main.All.css'];
    // this.printStyle =
    //   `
    //   th{
    //     background-color: #f5f5f7 !important;
    //  }
    //  `;
   }
   //打印完需要执行代码
  //  printComplete() {
  //    // this.printBtnBoolean = true;
  //   }
   
  //   beforePrint() {
     
  //    // this.printBtnBoolean = false;
  //   }
    
  ngOnInit() {
    if(this.param['headerLogo']) {
      this.headerLogo = this.param['headerLogo']
    }
     this.datasTitle = this.param['datasTitle'];
     this.datas = this.param['datas'];
  }

  /**
   * 打印
   */
  printHtml() {
    let iframe = document.createElement('IFRAME');
    let doc = null;
    iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
    iframe.setAttribute('class', 'print-iframe');
    document.body.appendChild(iframe);
    doc = iframe['contentWindow'].document;
    let html = $("#gridContainer").html();
    doc.write('<div>' + html + '</div>');
    doc.close();
    iframe['contentWindow'].focus();
    iframe['contentWindow'].print();
    if (navigator.userAgent.indexOf("MSIE") > 0) {
        document.body.removeChild(iframe);
    }
  }
  /**
   * 取消
   */
  cancelCancel() {
    $("#body").find('.print-iframe').remove()
    this.callback.emit()
  }



}